class CustomFilters extends HTMLElement {
  constructor() {
    super();
    this.initElements();
    this.attachEventListeners();
    this.loadFiltersFromStorage();
  }

  initElements() {
    this.checkedFilter = [];
    this.openButton = this.querySelector('[data-open]');
    this.closeButton = this.querySelector('[data-close]');
    this.sortNormal = this.querySelector('[data-normal]');
    this.sortVegan = this.querySelector('[data-vegan]');
    this.applyButton = this.querySelector('[data-apply]');
    this.clearButton = this.querySelector('[data-clear]');
    this.modal = this.querySelector('[data-modal]');
    this.filters = this.querySelectorAll('[data-filter]');
    this.picked = this.querySelectorAll('[data-picked]');
    this.blogs = this.querySelectorAll('[data-blog]');
  }

  attachEventListeners() {
    this.openButton.addEventListener('click', () => this.openModal());
    this.closeButton.addEventListener('click', () => this.closeModal());
    this.sortNormal.addEventListener('click', () => this.setActiveSort('normal'));
    this.sortVegan.addEventListener('click', () => this.setActiveSort('vegan'));
    this.clearButton.addEventListener('click', () => this.clearFilters());
    this.applyButton.addEventListener('click', () => this.applyFilters());

    this.filters.forEach(filter => {
      filter.addEventListener('change', () => {
        this.updateCheckedFilters();
        this.saveFiltersToStorage();
      });
    });

    this.picked.forEach(pick => {
      pick.addEventListener('change', () => {
        this.removePickedFilters();
        this.saveFiltersToStorage();
      });
    });

    this.modal.addEventListener('click', (event) => {
      if (event.target === this.modal) {
        this.closeModal();
      }
    });
  }

  setActiveSort(type) {
    if (type === 'normal') {
      this.sortNormal.setAttribute('data-active', '');
      this.sortVegan.removeAttribute('data-active');
      this.showFilters('normal');
    } else {
      this.sortVegan.setAttribute('data-active', '');
      this.sortNormal.removeAttribute('data-active');
      this.showFilters('vegan');
    }
  }

  showFilters(type) {
    this.filters.forEach(filter => {
      filter.nextElementSibling.toggleAttribute('data-show', filter.nextElementSibling.dataset.type === type);
    });
  }

  openModal() {
    this.picked[0].parentElement.removeAttribute('data-show');
    this.modal.setAttribute('data-open', '');
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    this.picked[0].parentElement.setAttribute('data-show', '');
    this.modal.removeAttribute('data-open');
    document.body.style.overflow = '';
  }

  updateCheckedFilters() {
    this.checkedFilter = [];

    this.filters.forEach((filter, index) => {
      if (filter.checked) {
        this.checkedFilter.push(filter.value);
        if (this.picked[index]) {
          this.picked[index].checked = true;
        }
      } else {
        if (this.picked[index]) {
          this.picked[index].checked = false;
        }
      }
    });

    this.saveFiltersToStorage();
  }

  removePickedFilters() {
    this.picked.forEach((pick, index) => {
      if (!pick.checked && this.filters[index]) {
        this.filters[index].checked = false;
      }
    });

    this.updateCheckedFilters();
    this.applyFilters();
  }

  clearFilters() {
    this.checkedFilter = [];
    this.filters.forEach(filter => (filter.checked = false));
    this.picked.forEach(pick => (pick.checked = false));
    this.blogs.forEach(blog => blog.removeAttribute('data-show'));

    localStorage.removeItem('filters');
    localStorage.removeItem('picked');
  }

  applyFilters() {
    let matched = false;

    this.blogs.forEach(blog => {
      const blogTags = blog.dataset.blog.split(',');
      const shouldShow = this.checkedFilter.some(filterId => blogTags.includes(filterId));

      if (shouldShow) {
        matched = true;
      }

      blog.setAttribute('data-show', shouldShow);
    });

    this.closeModal();

    if (!matched) {
      this.clearFilters();
    }
  }

  saveFiltersToStorage() {
    const filtersState = Array.from(this.filters).map(filter => filter.checked);
    const pickedState = Array.from(this.picked).map(pick => pick.checked);

    localStorage.setItem('filters', JSON.stringify(filtersState));
    localStorage.setItem('picked', JSON.stringify(pickedState));
  }

  loadFiltersFromStorage() {
    const savedFilters = JSON.parse(localStorage.getItem('filters'));
    const savedPicked = JSON.parse(localStorage.getItem('picked'));

    if (savedFilters) {
      this.filters.forEach((filter, index) => {
        filter.checked = savedFilters[index] || false;
      });
    }

    if (savedPicked) {
      this.picked.forEach((pick, index) => {
        pick.checked = savedPicked[index] || false;
      });
    }

    this.updateCheckedFilters();
    this.applyFilters();
  }
}

customElements.define('custom-filters', CustomFilters);
